<template>
  <v-container
    id="data-management"
    tag="section"
  >
    <base-resource-grid
      ref="resourceGrid"
      color="orange"
      icon="mdi-form-dropdown"
      plural-name="Dropdowns"
      singular-name="Dropdown"
      allow-expand
      :headers="headers"
      :resource="dropdownDetailResource"
      :fetch-method="getDropdownDetail"
      :actions="actions"
      @handleAction="handleAction"
    >
      <template v-slot:gridInteractions>
        <base-resource-select
          label="Filter By Section"
          item-text="section"
          item-value="id"
          bind-text="section"
          bind-value="dropdownId"
          :bind-item="selectedSection"
          :resource="sectionResource"
          @change="filtersChanged"
        />
      </template>
      <template v-slot:editForm="bindings">
        <v-row>
          <v-col
            cols="12"
          >
            <base-resource-select
              v-if="bindings && bindings.editedItem"
              label="Section"
              item-text="section"
              item-value="id"
              bind-text="section"
              bind-value="dropdownId"
              :bind-item="bindings.editedItem"
              :error-messages="bindings.formErrors.DropdownTypeId"
              :resource="sectionResource"
            />
            <v-text-field
              v-model="bindings.editedItem.keyValue"
              :error-messages="bindings.formErrors.KeyValue"
              label="Key Value"
            />
          </v-col>
        </v-row>
      </template>
    </base-resource-grid>
    <base-material-snackbar
      v-model="displayError"
      type="error"
      v-bind="{
        top: true,
        right: true
      }"
    >
      {{ errorMessage }}
    </base-material-snackbar>
    <base-history-dialog
      resource-endpoint="dropdownDetailHistory/"
      id-field="dropdownDetailId"
      title-field="dropdownDetail"
      color="orange"
      :columns="headers"
      :item="historyItem"
      @hide="historyItem = null"
    />
  </v-container>
</template>

<script>
  import TroodyApi from '@/services/troody/TroodyApi'

  export default {
    name: 'Dropdowns',

    data: () => ({
      sections: null,
      headers: [
        {
          text: 'Section',
          value: 'section',
        },
        {
          text: 'Key Value',
          value: 'keyValue',
        },
      ],

      actions: [
        {
          color: 'info',
          icon: 'mdi-information-variant',
          action: 'history',
        },
      ],

      selectedSection: {},

      dropdownDetailResource: new TroodyApi('dropdownDetail/'),

      historyItem: null,

      sectionResource: new TroodyApi('dropdown/'),

      errorMessage: null,

      displayError: false,
    }),

    methods: {
      getDropdownDetail () {
        if (this.selectedSection.dropdownId) {
          return this.dropdownDetailResource.query({ dropdownId: this.selectedSection.dropdownId })
        } else {
          return this.dropdownDetailResource.getList()
        }
      },

      filtersChanged () {
        this.$refs.resourceGrid.refresh()
      },

      handleAction (action, data) {
        if (action === 'history') {
          this.historyItem = data
        }
      },

      showError (error, msg) {
        console.log(error)
        this.errorMessage = (error || msg)
        this.displayError = true
      },
    },
  }
</script>
